<template>
  <div class="section__breadcrumbs">
    <NuxtLink class="link" to="/">
      {{ $t('breadcrumbs.homepage') }}
      <DefaultIconsChevronRight/>
    </NuxtLink>
    <span v-if="props.text" v-html="text" />
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  text: {type: String, required: false}
})
</script>